module.exports = __webpack_public_path__ + "media/src/images/certificates/frame_blue_de-42ef89ec75d8b5d2bfabcf664fdc5f4b.png";